import React from 'react';
import { withRouter } from 'react-router-dom';
import { systemText } from '../../helpers/string';

const isTouch = require('is-touch');
const screenWidth = window.innerWidth;

export const AsideLeft = props => {
	const [search, setSearch] = React.useState('');

	const user = props.user;

	const changeSearch = e => {
		setSearch(e.target.value);
	};

	const doSearch = e => {
		e.preventDefault();
		props.trackEvent('search');
		props.history.push(`/search/${search}`);
	};

	const toggleLeftAsideMenu = (index, link) => {
		if (!link) props.toggleLeftAsideMenu(index);
	};

	React.useEffect(() => {
		const sideMenus = props.menus;
		const path = props.location.pathname;
		if (props.location.pathname !== path) {
			sideMenus.forEach((p, i) => {
				if (p.route === path) toggleLeftAsideMenu(i);
				p.children &&
					p.children.forEach(c => {
						if (c.route === path) toggleLeftAsideMenu(i);
					});
			});
		}
	}, [props.menus, props.location]);

	const notAllowed = (menu, user) => {
		const manager = user.staff > 0;
		const management = user.managers > 0;
		const trainer = user.trainer;
		const coach = user.coaching_Ids?.length > 0;
		const admin = user.administrator;

		let allowed = false;

		allowed = allowed || !menu.allowed;
		allowed = allowed || (manager && menu.allowed?.some(x => x === 'managers'));
		allowed = allowed || (management && menu.allowed?.some(x => x === 'management'));
		allowed = allowed || (trainer && menu.allowed?.some(x => x === 'trainers'));
		allowed = allowed || (admin && menu.allowed?.some(x => x === 'admin'));
		allowed = allowed || (coach && menu.allowed?.some(x => x === 'coach'));

		return !allowed;
	};

	const sideMenus = props.menus || menus;

	const isMenuOpen = index => {
		return props.leftAsideMenusOpen.length > index - 1 && props.leftAsideMenusOpen[index];
	};

	const openLink = (link, trackingName) => {
		if (isTouch && screenWidth < 768) {
			props.toggleLeftAside();
		}

		props.trackEvent(trackingName);
		props.history.push(link);
	};

	const SafeLink = ({ children, to, trackingName, ...props }) => {
		return (
			<a
				{...props}
				onKeyUp={e => e.key === 'Enter' && openLink(to, trackingName)}
				onClick={() => openLink(to, trackingName)}
			>
				{children}
			</a>
		);
	};

	let searchText = systemText('Menus/Search');
	searchText = searchText === 'Menus/Search' ? 'Search...' : searchText;

	return (
		<aside className="main-sidebar">
			<section className="sidebar">
				{props.showSearch && (
					<form method="get" className="sidebar-form" onSubmit={doSearch}>
						<div className="input-group">
							<input
								tabIndex="20"
								onChange={changeSearch}
								value={search}
								type="search"
								className="form-control"
								placeholder={searchText}
							/>
							<span className="input-group-btn">
								<button
									tabIndex="20"
									type="submit"
									name="search"
									id="search-btn"
									className="btn"
									aria-label="Search"
								>
									<i className="fa fa-search" />
								</button>
							</span>
						</div>
					</form>
				)}
				<ul className="sidebar-menu">
					{sideMenus.map((menu, index) => {
						const open = isMenuOpen(index);
						const id = menu.route
							? menu.route.replaceAll('/', '-')
							: menu.title.replaceAll(' ', '-').toLowerCase();
						if (notAllowed(menu, user)) return null;

						return (
							<li
								key={index}
								id={id}
								className={`${open ? 'active' : ''} ${
									menu.children && menu.children.length > 0 ? 'treeview' : ''
								}`}
							>
								{menu.route ? (
									<SafeLink
										tabIndex="20"
										to={menu.route}
										trackingName={menu.trackingName}
										onClick={() => toggleLeftAsideMenu(index, true)}
									>
										<i className={menu.iconClass} />
										<span className="ml5">{menu.title}</span>
										{menu.children && menu.children.length > 0 && (
											<i className="fa fa-angle-left pull-right" />
										)}
									</SafeLink>
								) : (
									<a
										tabIndex="20"
										onKeyDown={e => e.key === 'Enter' && toggleLeftAsideMenu(index)}
										onClick={() => toggleLeftAsideMenu(index)}
									>
										<i className={menu.iconClass} />
										<span className="ml5">{menu.title}</span>
										{menu.children && menu.children.length > 0 && (
											<i className="fa fa-angle-left pull-right" />
										)}
									</a>
								)}
								{menu.children && menu.children.length > 0 && (
									<ul className="hold-transition treeview-menu">
										{menu.children.map((subMenu, subIndex) => {
											const subId = subMenu.route
												? subMenu.route.replaceAll('/', '-')
												: subMenu.title.replaceAll(' ', '-').toLowerCase();
											if (notAllowed(subMenu, user)) return null;
											return (
												<li
													key={subIndex}
													id={subId}
													className={subMenu.route === location.pathname ? 'active' : ''}
												>
													<SafeLink
														tabIndex="20"
														to={subMenu.route}
														trackingName={subMenu.trackingName}
														onClick={() => toggleLeftAsideMenu(index, true)}
													>
														<i className="fa fa-caret-right text-sm" /> {subMenu.title}
													</SafeLink>
												</li>
											);
										})}
									</ul>
								)}
							</li>
						);
					})}
				</ul>
			</section>
			{props.extra}
		</aside>
	);
};

export default withRouter(AsideLeft);
